import { JSX, h, Fragment } from 'preact';

import { CustomerSection, CustomerSectionProps } from './CustomerSection';
import { EventDetails, EventDetailsProps } from './EventDetails';
import { Floorplan, FloorplanProps } from './FloorPlan';
import { InternalInfo, InternalInfoProps } from './InternalInfo';
import { Poster, PosterProps } from './Poster';
import { TabMenu, TabMenuProps } from './TabMenu';
import { TicketSystem, TicketSystemProps } from './TicketSystem';
import { TicketTypesTable, TicketTypesTableProps } from './TicketTypesTable';

export interface TicketViewProps {
    tabMenu: TabMenuProps;
    title: string;
    originalTitle: string;
    countries: string;
    internalInfo?: InternalInfoProps;
    poster?: PosterProps;
    ticketSystem: TicketSystemProps;
    eventDetails: EventDetailsProps;
    availableTicketsTitle: string;
    availableTicketsClass: string;
    capacityWarning?: string;
    ticketTypesTable: TicketTypesTableProps;
    seatsTitle: string;
    floorPlan?: FloorplanProps;
    customerTitle: string;
    customerSection: CustomerSectionProps;
}

export const TicketView = (props: TicketViewProps): JSX.Element => (
    <Fragment>
        <TabMenu {...props.tabMenu} />
        <div class='flex mt-8 mb-12'>
            <Poster {...props.poster} />
            <div>
                <div class='flex flex-col gap-2'>
                    <div class='flex items-center gap-4'>
                        <h1>{props.title}</h1>
                        {props.internalInfo && (
                            <InternalInfo {...props.internalInfo} class='' />
                        )}
                    </div>
                    {props.originalTitle && (
                        <div class='text-neutral-400'>
                            {props.originalTitle}
                            {props.countries && (
                                <span>, {props.countries}</span>
                            )}
                        </div>
                    )}
                </div>
                <EventDetails {...props.eventDetails} />
            </div>
        </div>
        <TicketSystem {...props.ticketSystem} class='' />
        {props.capacityWarning && (
            <div class='my-6 p-4 bg-kinola-red bg-opacity-10 border-l-4 border-kinola-red' role='alert' aria-live='polite'>
                <div class='flex items-start gap-3'>
                    <svg xmlns='http://www.w3.org/2000/svg' class='h-6 w-6 text-kinola-red flex-shrink-0' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'>
                        <path stroke-linecap='round' stroke-linejoin='round' d='M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z' />
                    </svg>
                    <div class='text-kinola-red k-body-bold'>{props.capacityWarning}</div>
                </div>
            </div>
        )}
        {props.floorPlan && (
            <div class='my-12 last:mb-0'>
                <Floorplan {...props.floorPlan} />
            </div>
        )}
        {props.ticketTypesTable && (
            <div class='my-12 last:mb-0'>
                <div class={props.availableTicketsClass}>{props.availableTicketsTitle}</div>
                <TicketTypesTable {...props.ticketTypesTable} />
            </div>
        )}
        {props.customerSection && (
            <div class='my-12 last:mb-0'>
                <h3 class='mb-6'>{props.customerTitle}</h3>
                <CustomerSection {...props.customerSection} />
            </div>
        )}
    </Fragment>
);
